export default {
  dbi_company_company_lowercase: 'company',
  dbi_company_companies: 'Companies',
  dbi_company_game_type: 'Game Type',
  dbi_company_ipo_status: 'IPO Status',
  dbi_company_headquaters: 'Headquaters',
  dbi_company_public: 'Public',
  dbi_company_private: 'Private',
  dbi_company_delisted: 'Delisted',
  dbi_company_game_owned: 'Games Owned',
  dbi_company_listed: 'Listed',
  dbi_company_and: ' and ',
  dbi_company_company_revenue: 'Company Revenue',
  dbi_company_company_downloads: 'Company Downloads',
  dbi_company_filter_tips_1_row: 'Physical copy sales revenue of PC and console game comes from NPD,',
  dbi_company_filter_tips_2_row: 'covering US only.',
  dbi_company_filter_tips_3_row: 'Digital revenue of PC and console games comes from M Science,',
  dbi_company_filter_tips_4_row: 'covering US, UK, DE, FR and ES.',
  dbi_company_metrics_sum_revenue: 'Sum Revenue($)',
  dbi_company_metrics_mobile_revenue: 'Mobile Revenue($)',
  dbi_company_metrics_pc_revenue: 'PC Revenue($)',
  dbi_company_metrics_pc_digital_revenue: 'PC Digital Revenue($)',
  dbi_company_metrics_pc_physical_revenue: 'PC Physical Revenue($)',
  dbi_company_metrics_console_revenue: 'Console Revenue($)',
  dbi_company_metrics_console_digital_revenue: 'Console Digital REV($)',
  dbi_company_metrics_console_physical_revenue: 'Console Physical Revenue($)',
  dbi_company_cb_info_tips: 'Crunchbase provides company descriptions,financial activities and team members.',
  dbi_company_tables_info_tips1: 'Sum up the revenue of game types you choose.',
  dbi_company_tables_info_tips2:
    'Revenue from NPD (US data only) and Mscience are (US, UK, FR, DE and ES data only) aggregated here.',
  dbi_company_downloads_mentions_info_tips:
    'Items are listed in descending order by this metric defaultiy.Please select items for selected information only.Sources:',

  dbi_company_parent: 'Parent',
  dbi_company_subsidiary: 'Subsidiary',

  dbi_company_tab_newsactivity: 'News&Activity',
  dbi_company_tab_gamesstats: 'Games&Stats',
  dbi_company_tab_subsidiary_companies: 'Subsidiary Companies',
  dbi_company_tab_similar_companies: 'Similar Companies',

  dbi_company_media_news: 'Media News',
  dbi_company_new_games: 'New Games',
  dbi_company_activities: 'Activities',

  dbi_company_about: 'About',
  dbi_company_employee: 'Employee',
  dbi_company_founded_date: 'Founded Date',
  dbi_company_last_funding_type: 'Last Funding Type',
  dbi_company_also_known_as: 'Also Known As',
  dbi_company_website: 'Website',

  dbi_company_game_performance_summary: 'Game Performance Summary',
  dbi_company_game_performance_summary_tips:
    'Here shows the game-related metrics, regardless of being game publisher or developer.',
  dbi_company_recent_news_activity: 'Recent News & Activity',
  dbi_company_original_news: 'Original News',

  dbi_company_news_activity_original_text: 'Original Text',
  dbi_company_news_activity_translate_to_en: 'Translate all to English',
  dbi_company_news_activity_translate_to_cn: 'Translate all to Chinese',
  dbi_company_mobile_metrics: 'Mobile Metrics',
  dbi_company_pc_metrics: 'PC Metrics',
  dbi_company_console_metrics: 'Console Metrics',
  dbi_company_units_company: `Unit % of Company`,
  dbi_company_revenue_company: `Revenue % of Company`,
  dbi_company_revenue$_company: `Revenue($) % of Company`,
  dbi_company_download_company: `Downloads % of Company`,

  dbi_company_go_to: 'Go to',

  dbi_company_ipo_stock_price: 'IPO & Stock Price',
  dbi_company_investments: '$ Investments',
  dbi_company_investors: '$ Investors',
  dbi_company_founding_round: 'Founding Round',
  dbi_company_acquisitions: '$ Acquisitions',
  dbi_company_exits: '$ Exits',
  dbi_company_ticker: ' is registered under the ticker',
  dbi_company_symbol: 'Stock Symbol',
  dbi_company_exiValuatlin: 'Valuatlin at IPOts',
  dbi_company_ipo_date: 'IPO Date',
  dbi_company_number_investments: 'Number of Investments',
  dbi_company_number_lead_investments: 'Number of Lead Investments',
  dbi_company_announced_date: 'Announced Date',
  dbi_company_organization_name: 'Organization Name',
  dbi_company_lead_investor: 'Lead Investor',
  dbi_company_money: 'Money Raised($)',
  dbi_company_number_investors: 'Number of Investors',
  dbi_company_number_lead_investors: 'Number of Lead Investors',
  dbi_company_investors_name: 'Investors Name',
  dbi_company_partners: 'Partners',
  dbi_company_number_funding_rounds: 'Number of Funding Rounds',
  dbi_company_total_funding_amount: 'Total Funding Amount',
  dbi_company_transaction_name: 'Transaction Name',
  dbi_company_number_acquisitions: 'Number of Acquisitions',
  dbi_company_acquiree_name: 'Acquiree Name',
  dbi_company_price: 'Price($)',
  dbi_company_number_exits: 'Number of Exits',
  dbi_company_current_team: 'Current Team',
  dbi_company_andrew_wilson: 'current team members,including Founder, CEO & Executive Director {message}',
  dbi_company_number_members: 'Number of Current Team Members',
  dbi_company_members_advisors: 'Board Members and Advisors',
  dbi_company_holdings_members: 'board members and advisors,including {message}',
  dbi_company_members_person: 'Number of Board Members / Advisors',
  dbi_company_entity_select_label: 'All entities related',
};
